import { Currency, ProductCategory, ProductStockStatus, ProductType } from '../src/constants';
import { Product } from '../src/model';

export const mockProduct: Product = {
  productId: 40353,
  sku: '100004626',
  name: 'Mung Bean Mild Acidic Cleansing Foam',
  brand: 'beplain',
  productLink: 'https://dev.skin-seoul.com/product/beplain-mung-bean-mild-acidic-cleansing-foam/',
  productImageUrls: [
    'https://dev.skin-seoul.com/wp-content/uploads/2025/07/thu_100004626_1-1.webp',
    'https://dev.skin-seoul.com/wp-content/uploads/2025/07/thu_100004626_1-1.webp',
    'https://dev.skin-seoul.com/wp-content/uploads/2025/07/thu_100004626_1-1.webp',
  ],
  category: [ProductCategory.CLEANSING_FOAM],
  modifiedAt: '2025-07-13T18:42:49.000Z',
  size: '80ml',
  pack: '1pack| 2packs| 3packs| 5packs',
  originalPrice: 8.27,
  salePrice: 6.27,
  currency: Currency.UnitedStates,
  type: ProductType.Variable,
  status: ProductStockStatus.instock,
  description:
    'The beplain Mung Bean Mild Acidic Cleansing Foam is designed for gentle and effective cleansing, featuring mung bean powder and a mild acidic pH of around 5.5 to cater to sensitive skin, while its water-soluble polymer ingredients enhance foam generation and retention for a comfortable cleansing experience.',
  additionalPrices: [],
  variations: [
    {
      productId: 40355,
      sku: '100002285',
      name: 'Mung Bean Mild Acidic Cleansing Foam',
      brand: 'beplain',
      productLink: 'https://dev.skin-seoul.com/product/beplain-mung-bean-mild-acidic-cleansing-foam-5/',
      productImageUrls: ['https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100002285_1-1.webp'],
      category: [ProductCategory.CLEANSING_FOAM],
      modifiedAt: '2025-07-05T00:12:05.000Z',
      size: '80ml',
      pack: '1pack',
      originalPrice: 7.884717008999998,
      currency: Currency.UnitedStates,
      type: ProductType.Variation,
      status: ProductStockStatus.instock,
      description: 'Select Size: 80ml, Choose Pack: 1pack',
      score: 24.5,
      additionalPrices: [],
      parentProductId: 40353,
    },
    {
      productId: 40356,
      sku: '100002286',
      name: 'Mung Bean Mild Acidic Cleansing Foam',
      brand: 'beplain',
      productLink: 'https://dev.skin-seoul.com/product/beplain-mung-bean-mild-acidic-cleansing-foam-6/',
      productImageUrls: ['https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100002286_1-1.webp'],
      category: [ProductCategory.CLEANSING_FOAM],
      modifiedAt: '2025-07-04T23:47:46.000Z',
      size: '80ml',
      pack: '2packs',
      originalPrice: 15.302457611999998,
      currency: Currency.UnitedStates,
      type: ProductType.Variation,
      status: ProductStockStatus.instock,
      description: 'Select Size: 80ml, Choose Pack: 2packs',
      score: 24.5,
      additionalPrices: [],
      parentProductId: 40353,
    },
    {
      productId: 70043,
      sku: '100006841',
      name: 'Mung Bean Mild Acidic Cleansing Foam',
      brand: 'beplain',
      productLink: 'https://dev.skin-seoul.com/product/beplain-mung-bean-ph-balanced-cleansing-foam/',
      productImageUrls: [
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100006841_1-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100006841_10-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100006841_2-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100006841_3-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100006841_4-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100006841_5-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100006841_6-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100006841_7-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100006841_8-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100006841_9-1.webp',
      ],
      category: [ProductCategory.CLEANSING_FOAM],
      modifiedAt: '2025-07-05T00:12:05.000Z',
      size: '80ml',
      pack: '1pack',
      originalPrice: 7.884717008999998,
      currency: Currency.UnitedStates,
      type: ProductType.Variation,
      status: ProductStockStatus.instock,
      description: 'Select Size: 80ml, Choose Pack: 1pack',
      score: 24.5,
      additionalPrices: [],
      parentProductId: 40353,
    },
    {
      productId: 74998,
      sku: '100005350',
      name: 'Mung Bean Mild Acidic Cleansing Foam',
      brand: 'beplain',
      productLink: 'https://dev.skin-seoul.com/product/beplain-mung-bean-mildly-acidic-cleansing-foam-80ml-5pcs/',
      productImageUrls: [
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005350_1-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005350_10-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005350_2-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005350_3-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005350_4-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005350_5-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005350_6-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005350_7-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005350_8-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005350_9-1.webp',
      ],
      category: [ProductCategory.CLEANSING_FOAM],
      modifiedAt: '2025-07-04T22:21:03.000Z',
      size: '80ml',
      pack: '5packs',
      originalPrice: 36.478041561,
      currency: Currency.UnitedStates,
      type: ProductType.Variation,
      status: ProductStockStatus.instock,
      description: 'Select Size: 80ml, Choose Pack: 5packs',
      score: 24.5,
      additionalPrices: [],
      parentProductId: 40353,
    },
    {
      productId: 74999,
      sku: '100005349',
      name: 'Mung Bean Mild Acidic Cleansing Foam',
      brand: 'beplain',
      productLink: 'https://dev.skin-seoul.com/product/beplain-mung-bean-mildly-acidic-cleansing-foam-80ml-3pcs/',
      productImageUrls: [
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005349_1-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005349_10-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005349_2-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005349_3-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005349_4-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005349_5-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005349_6-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005349_7-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005349_8-1.webp',
        'https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005349_9-1.webp',
      ],
      category: [ProductCategory.CLEANSING_FOAM],
      modifiedAt: '2025-07-04T23:11:00.000Z',
      size: '80ml',
      pack: '3packs',
      originalPrice: 22.594473798,
      currency: Currency.UnitedStates,
      type: ProductType.Variation,
      status: ProductStockStatus.instock,
      description: 'Select Size: 80ml, Choose Pack: 3packs',
      score: 24.5,
      additionalPrices: [],
      parentProductId: 40353,
    },
    {
      productId: 75000,
      sku: '100005348',
      name: 'Mung Bean Mild Acidic Cleansing Foam',
      brand: 'beplain',
      productLink: 'https://dev.skin-seoul.com/product/beplain-mung-bean-mildly-acidic-cleansing-foam-160ml-3pcs/',
      productImageUrls: ['https://prod.skin-seoul.com/wp-content/uploads/2024/05/thu_100005348_1-1.webp'],
      category: [ProductCategory.CLEANSING_FOAM],
      modifiedAt: '2025-07-04T18:51:41.000Z',
      size: '160ml',
      pack: '3packs',
      originalPrice: 43.0606128225,
      currency: Currency.UnitedStates,
      type: ProductType.Variation,
      status: ProductStockStatus.outofstock,
      description: 'Select Size: 160ml, Choose Pack: 3packs',
      score: 24.5,
      additionalPrices: [],
      parentProductId: 40353,
    },
  ],
};
